import { render, staticRenderFns } from "./IGB2BInsurerCodeSelect.vue?vue&type=template&id=dec4a4ec"
import script from "./IGB2BInsurerCodeSelect.vue?vue&type=script&lang=js"
export * from "./IGB2BInsurerCodeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports